import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LanguageModule } from '@language';
import { ShIconModule } from '../elements/components/icon/icon.module';
import { ShNotificationComponent } from '../elements/components/notification/notification.component';

import { EmlViewerComponent } from './components/eml-viewer/eml-viewer.component';
import { ImageViewerComponent } from './components/image-viewer/image-viewer.component';
import { PdfViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { VideoViewerComponent } from './components/video-viewer/video-viewer.component';
import { ViewerComponent } from './components/viewer/viewer.component';
import { ViewerContainerComponent } from './containers/viewer-container/viewer-container.component';
import { ViewerSandboxService } from './sandbox/viewer-sandbox.service';
import { ViewerRoutingModule } from './viewer-routing.module';
import { ShRecordDownloadService } from '../core/exports/services/record-download.service';

@NgModule({
    imports: [
        CommonModule,
        ViewerRoutingModule,
        ShNotificationComponent,
        ShIconModule,
        LanguageModule,
        ViewerContainerComponent,
        ViewerComponent,
        ImageViewerComponent,
        PdfViewerComponent,
        VideoViewerComponent,
        EmlViewerComponent
    ],
    providers: [ViewerSandboxService, ShRecordDownloadService]
})
export class ViewerModule {}

export * from './helper/extension-to-viewer.helper';
